import clsx from 'clsx';
import {
  CalendarDaysIcon,
  ChartBarIcon,
  ChevronRightIcon,
  ListBulletIcon,
} from '@heroicons/react/24/outline';
import { MapPinIcon } from '@heroicons/react/24/solid';
import type { SignupSheet } from '@flock-types/signupSheets.types';

interface Props {
  sheet: SignupSheet;
  onOpen: (sheet: SignupSheet) => void;
}

const TYPE_META = {
  date: { label: 'Date list', Icon: CalendarDaysIcon },
  item: { label: 'Item list', Icon: ListBulletIcon },
  survey: { label: 'Survey', Icon: ChartBarIcon },
} as const;

/** Sheet row in the list pane (port of the Expo signup-sheets/index card). */
export default function SheetCard({ sheet, onOpen }: Props) {
  const openSlots = Number(sheet.open_slots) || 0;
  const totalSlots = Number(sheet.total_slots) || 0;
  const filledSlots = totalSlots - openSlots;
  const { label, Icon } = TYPE_META[sheet.sheet_type] ?? TYPE_META.item;

  return (
    <button
      onClick={() => onOpen(sheet)}
      className="flex w-full items-center gap-3 rounded-xl border border-flock-gray-200 bg-white p-4 text-left transition hover:border-flock-navy-300 hover:shadow-sm"
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          {sheet.is_pinned && <MapPinIcon className="h-4 w-4 shrink-0 text-amber-500" />}
          <span className="truncate text-base font-semibold text-flock-navy-900">
            {sheet.title}
          </span>
        </div>
        <div className="mt-1 flex items-center gap-1 text-sm text-flock-navy-500">
          <Icon className="h-4 w-4" />
          <span>
            {label} · {openSlots > 0 ? `${openSlots} open` : 'All filled'}
            {totalSlots > 0 ? ` of ${totalSlots}` : ''}
          </span>
        </div>
      </div>
      {totalSlots > 0 && (
        <span
          className={clsx(
            'shrink-0 text-sm font-medium',
            openSlots === 0 ? 'text-green-600' : 'text-flock-navy-600'
          )}
        >
          {filledSlots}/{totalSlots}
        </span>
      )}
      <ChevronRightIcon className="h-5 w-5 shrink-0 text-flock-navy-300" />
    </button>
  );
}
